import React, { useEffect } from "react";
import { BasePageModal } from "@/shared/components/modal/page-modal/base-page-modal";
import { BaseRoundButton } from "@/shared/components/button/base-round-button";
import { usePostCsvExcelAccount } from "@/features/accounts/csv-excel/hooks/use-post-accounts";
import { usePostCsvExcelAccountsStates } from "@/features/accounts/csv-excel/hooks/use-post-accounts-states";
import { SimpleForm } from "@/shared/components/text-box/simple-form";
import { useAccountGroupsContext } from "@/features/accounts/account-group/contexts/account-groups-context";
import { useModalContext } from "@/shared/components/modal/contexts/modal-context";
import { useInstitutionsContext } from "@/features/institutions/contexts/institutions-context";

interface Props {
  onCloseModal: () => void;
  onCompleteModal: (csvExcelAccountId: string) => void;
}

export const RegisterCsvAccountModal = ({ onCloseModal, onCompleteModal }: Props) => {
  const {
    selectedAccountGroup,
  } = useAccountGroupsContext();
  const { setOpenHomeModal } = useModalContext();
  const {
    registerCsvExcelAccounts,
  } = usePostCsvExcelAccount();
  const { companyCode } = useInstitutionsContext();
  const {
    isActiveRegisterButton,
    setIsActiveRegisterButton,
    passbookName,
    setPassbookName,
  } = usePostCsvExcelAccountsStates();

  useEffect(() => {
    setIsActiveRegisterButton(passbookName !== "");
  }, [passbookName]);

  const handleRegister = async () => {
    const trimmedPassbookName = passbookName.trim();
    const res = await registerCsvExcelAccounts(
      selectedAccountGroup.accountGroupId,
      trimmedPassbookName,
      1,
      companyCode,
    );
    if (res) {
      onCompleteModal(res);
      setOpenHomeModal("FirstUploadCsv");
    }
  };

  return (
    <BasePageModal
      className="md-new-excel"
      handleClose={onCloseModal}
      title="CSV用Web明細帳を作成"
      bottomChildren={
        <BaseRoundButton
          buttonText="次へ"
          onClick={handleRegister}
          isActive={isActiveRegisterButton}
        />
      }
      disableOverlayClose={true}
    >
      <h2>Web明細帳名を設定してください</h2>
      <dl>
        <SimpleForm
          title="Web明細帳名"
          id="csvName"
          placeholder="Web明細帳名を入力（必須）"
          onChange={(newValue) => setPassbookName(newValue)}
          labelEnable={true}
          descriptionType={true}
        />
      </dl>
    </BasePageModal>
  );
};
